import $ from "jquery";

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

$(document).ready(function () {
    validateForm();
    tabSwitcher();

    $('.js-change-locale').on('change', function () {
        window.location.href = $(this).val();
    });

    $('.btn-menu').on('click', function (event) {
        $(this).toggleClass('btn-menu--active');

        $('.nav-utilities').toggleClass('open');

        event.preventDefault();
    });

    //Hide the inactive sections
    $('.accordion__section').not('.accordion__section--current').find('.accordion__body').hide();

    // Handle the show/hide logic
    $('.accordion').on('click', '.accordion__head', function (event) {
        $(this).next().stop().slideToggle()
            .parent().toggleClass('accordion__section--current')
            .siblings().removeClass('accordion__section--current')
            .find('.accordion__body').slideUp();

    });

    $("#versioned-pages-modals > div").modal({
        keyboard: false,
        backdrop: 'static',
        show: false,
    });
    $("#versioned-pages-modals > div:first-child").modal('show');

    if (typeof markAsViewedVersionedPage === "function") {
        markAsViewedVersionedPage();
    }

});

function tabSwitcher() {
    const activeTabClass = 'current';
    $('.tabs__nav a').on('click', function (event) {
        event.preventDefault();
        var $tabLink   = $(this);
        var $targetTab = $($tabLink.attr('href'));
        $tabLink
            .parent()
            .add($targetTab)
            .addClass(activeTabClass)
            .siblings()
            .removeClass(activeTabClass);
    });
}

$(window).on('load', function () {
    if ($('.google-map').length) {
        initMap();
    }
});

window.initMap = function initMap() {
    let map;
    var $singleMap = $('.google-map');
    var centerLat  = parseFloat($singleMap.data('lat'));
    var centerLng  = parseFloat($singleMap.data('lng'));
    var myLatLng   = {lat: centerLat, lng: centerLng};
    var bounds     = new google.maps.LatLngBounds();

    var mapOptions = {
        center     : myLatLng,
        zoom       : 13,
        mapTypeId  : google.maps.MapTypeId.roadmap,
        scrollwheel: false
    };

    map = new google.maps.Map($singleMap[0], mapOptions);
    let i;
    let marker;

    marker = new google.maps.Marker({
        position: myLatLng,
        map     : map
    });
}

function validateForm() {
    if (window.validation && window.validation.selector) {
        $(window.validation.selector).each(function () {
            $(this).validate({
                errorElement  : 'span',
                errorClass    : 'invalid-feedback',
                errorPlacement: function (error, element) {
                    if (element.parents('.radio-block').length) {
                        error.insertAfter(element.parents('.radio-block'));
                    } else if (element.parent('.input-group').length ||
                        element.prop('type') === 'checkbox' || element.prop('type') === 'radio') {
                        error.insertAfter(element.parent());
                        // else just place the validation message immediately after the input
                    } else {
                        error.insertAfter(element);
                    }
                },
                highlight     : function (element) {
                    $(element).closest('.form-control').removeClass('is-valid').addClass('is-invalid');
                    $(element).closest('.form__controls').removeClass('is-valid').addClass('is-invalid');// add the Bootstrap error class to the control group
                },
                unhighlight   : function (element) {
                    $(element).closest('.form-control').removeClass('is-invalid').addClass('is-valid');
                    $(element).closest('.form__controls').removeClass('is-invalid').addClass('is-valid');
                },
                success       : function (element) {
                    $(element).closest('.form-control').removeClass('is-invalid').addClass('is-valid'); // remove the Boostrap error class from the control group
                },
                focusInvalid  : false, // do not focus the last invalid input
                invalidHandler: function (form, validator) {
                    if (!validator.numberOfInvalids())
                        return;
                    $('html, body').animate({
                        scrollTop: $(validator.errorList[0].element).offset().top
                    }, 1000);
                    $(validator.errorList[0].element).focus();
                },
                rules         : window.validation.rules
            });
        });
    }
}

window.priceFormat = function priceFormat (value) {
   return new Intl.NumberFormat('en-UK', {minimumFractionDigits: 2, maximumFractionDigits: 2})
        .format(parseFloat(value))
}

